module.exports = __webpack_public_path__ + "img/diary-cover.3f69c1d.png";